import { environment } from 'environments/environment';

/**
 * Derives the Plaato device id from the plaato2 document id.
 *
 * The suffix is ENVIRONMENT-DEPENDENT and MUST match what the setup component writes to
 * the device (blynk-id): prod = '54', stage/dev = '00'. Pads to 32 chars with
 * '-'. If a command is sent with the wrong suffix (e.g. '-54' on stage), the
 * proxy cannot find the device → "Failed to send command to device".
 *
 * The single source of truth for the device-id format — used by configure,
 * plaato-realtime, content-mode and setup (blynk-id) so they always agree.
 */
export function plaatoDeviceId(plaato2DocId: string | undefined | null): string {
  const suffix = environment.production ? '54' : '00';
  return `${plaato2DocId ?? ''}-${suffix}`.padEnd(32, '-');
}
